import './styles.css';

import clsx from 'clsx';

type LoaderProps = {
	size?: 'xs' | 'sm' | 'md' | 'lg';
	type?: 'gap' | 'fullscreen';
	className?: string;
};

export function Loader({ size, type, className }: LoaderProps) {
	if (type === 'gap') {
		return (
			<div className="loader relative size-6">
				<span className="absolute left-3 top-0 h-[5px] w-[2px] bg-accent" />
				<span className="absolute left-3 top-0 h-[5px] w-[2px] bg-accent" />
				<span className="absolute left-3 top-0 h-[5px] w-[2px] bg-accent" />
				<span className="absolute left-3 top-0 h-[5px] w-[2px] bg-accent" />
				<span className="absolute left-3 top-0 h-[5px] w-[2px] bg-accent" />
				<span className="absolute left-3 top-0 h-[5px] w-[2px] bg-accent" />
				<span className="absolute left-3 top-0 h-[5px] w-[2px] bg-accent" />
				<span className="absolute left-3 top-0 h-[5px] w-[2px] bg-accent" />
			</div>
		);
	}

	const cl = clsx(
		{
			'size-3': size === 'xs',
			'size-4': size === 'sm',
			'size-5': size === 'md',
			'size-6': size === 'lg',
		},
		'animate-spin rounded-full border-4 border-gray-200 border-t-gray-300',
		'inline-block size-4',
		className,
	);

	if (type === 'fullscreen') {
		return (
			<div className="flex h-full w-full flex-1 items-center justify-center">
				<div className={cl} />
			</div>
		);
	}
	return <span className={cl} />;
}
